import React from 'react'
import { categoriesWithIcons } from 'keys/categories'
import { AssessmentCategoryCellStyles } from './Style'
import { SvgIcon } from '@mui/material'

const AssessmentCategoryCell = (props) => {
    const { row, column } = props
    const { meta } = column?.columnDef || {}
    const { original } = row
    const reading_assessment_category_label = original?.[meta?.label] || original.reading_assessment_category_label
    const reading_assessment_category_name = original?.[meta?.name] || original.reading_assessment_category_name
    const assessmentCategoryItem = categoriesWithIcons?.[reading_assessment_category_name] || categoriesWithIcons?.["default"]

    return (
        !reading_assessment_category_label ||
        <AssessmentCategoryCellStyles>
            <SvgIcon component={assessmentCategoryItem.icon} inheritViewBox />
            {reading_assessment_category_label}
        </AssessmentCategoryCellStyles>
    )
}

export default AssessmentCategoryCell